import React from 'react';

 import {Typography} from "@material-ui/core";
 import { ReactComponent as TwitterLogo } from '../resources/images/twitter.svg';
 import { ReactComponent as FacebookLogo } from '../resources/images/facebook.svg';

 const Footer = () => {
 return (
   <div className="Footer">
     <Typography variant="h6" className="DeutscheText" noWrap>Deutsche Post DHL Group</Typography>
     <div className="FooterContainer">
       <div className="FooterLinkContainer">
       <Typography variant="subtitle2" className="LinkHeaderText" noWrap>ENLACES RÁPIDOS</Typography>
       <div className="FooterLinks">
       <a rel="noopener noreferrer" target="_blank" href="https://www.dhl.com/mx-es/home/quienes-somos.html">
        <Typography variant="body1"  className="LinkText" noWrap>Acerca de DHL</Typography>
       </a>
       <a rel="noopener noreferrer" target="_blank" href="https://www.dhl.com/mx-es/home.html">
        <Typography variant="body1"  className="LinkText" noWrap>Página de inicio DHL</Typography>
       </a>
       <a rel="noopener noreferrer" target="_blank" href="https://www.dhl.com/mx-es/home/contactenos.html">
        <Typography variant="body1"  className="LinkText" noWrap>Contáctanos</Typography>
       </a>
       </div>
       </div>
       <div className="FooterIconContainer">
       <Typography variant="subtitle2" className="LinkHeaderText" noWrap>COMPARTIR</Typography>
       <div className="FooterIcons">
       <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/dhlmex">
       <TwitterLogo className="Icons"/>
       </a>
       <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/dhlmx">
       <FacebookLogo className="Icons"/>
       </a>
       </div>
       </div>
     </div>
   </div>
 );
 };

 export default Footer;
